import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IValidateFetchXMLModel } from '../interfaces/IValidateFetchXMLModel';
import { IDocumentConfiguration } from '../request/document-uploader/_interfaces/DocumentConfiguration';
import { DocumentOrigin } from '../enums/DocumentOrigin.enum';
import { IDeclaration } from '../interfaces/IDeclaration';
import { map } from 'rxjs/operators';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { ErrorStatus } from '../enums/ErrorStatus.enum';
import { Router } from '@angular/router';
import { LoaderService } from './loader.service';
import { Mode } from '../form-guide/utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { PopupNotificationComponent } from '../request/popup-notification/popup-notification.component';
import { RedirectionCode } from '../enums/RedirectionCode.enum';
import { NgxIndexedDBService } from 'ngx-indexed-db';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};
@Injectable({
  providedIn: 'root'
})

export class CommonService {

  private validateModel: IValidateFetchXMLModel;
  private baseUrl: string;
  isNewTab: boolean = false;
  alertModalRef: BsModalRef;
  confirmModalRef: BsModalRef;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private router: Router,
    private translate:TranslateService,
    private modalService: BsModalService,
    private dbService: NgxIndexedDBService) {

    this.appConfig.getAppConfigForCommonService().subscribe(data=>{
      if(data)
      this.baseUrl = data.AppUrl + '/api';
    });
  }

  GetParametersByName(name: string) {
   
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  formatDate(inputDate: string) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
      // Months use 0 index.
      let month = (date.getMonth() + 1).toString();
      let day = (date.getDate()).toString();
      if (parseInt(day) < 10) {
        day = "0" + day
      }
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      console.log(month);
      return day + '/' + month + '/' + date.getFullYear();
    }
  }
  downloadPDF(reportModel: any) {
    return this.http.post<object>(this.baseUrl + "/Documents/GenerateDocument?EntityLogicalName", reportModel, httpOptions)
      .pipe(
        // catchError(this.handleError('',))
      );
  }

   downloadReportByName(reportModel: any) {
    return this.http.post<object>(this.baseUrl + "/Documents/GenerateReportByName?EntityLogicalName", reportModel, httpOptions)
      .pipe(
        // catchError(this.handleError('',))
      );
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement('a');

    if (link.download !== undefined) { // HTML 5
      link.setAttribute("href", window.URL.createObjectURL(blob));
      link.setAttribute("type", blob.type);
      link.setAttribute("download", (reportName + ".pdf" || "report.pdf"));
      link.click();
      // @ts-ignore
    } else if (navigator.msSaveBlob) { // IE 10+
      // @ts-ignore
      navigator.msSaveBlob(blob, reportName + ".pdf");
    } else { // Non HTML 5
      link.setAttribute("href", "data:" + blob.type + "," + encodeURIComponent(""));
      link.click();
    }

    //link.href = window.URL.createObjectURL(blob);
    //var fileName = reportName;
    //link.download = fileName;
    //link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  };

  // ---------------------- commen APIs -----------------------

  CancelRequest(ApplicatinHeaderId: string): Observable<object> {
    return this.http.post<object>(this.baseUrl + '/App/CancelReuqest', JSON.stringify(ApplicatinHeaderId), httpOptions);
  }

  FetchXMLValidation(entityName: string, GroupByAlias: string, keyValue): Observable<boolean> {

    this.validateModel = {
      entityName: entityName,
      keyValues: keyValue,
      groupAlias: GroupByAlias
    }

    console.log(this.validateModel);

    return this.http.post<any>(this.baseUrl + "/App/ValidateFetchXML",
      this.validateModel,
      httpOptions);
  }

  GetServiceDeclaration(serviceId: string): Observable<IDeclaration> {

    return this.http.get<any>(this.baseUrl + `/App/GetServiceDeclaration?serviceId=${serviceId}`);
  }

  GetDocumentsConfigurations(requestModel: any, contarctName: string, getConifgWithoutStage: boolean = false, getFromActiveStage: boolean = false, ): Observable<IDocumentConfiguration[]> {
    const model = {
      Request: requestModel,
      origin: [DocumentOrigin.Portal, DocumentOrigin.Both],
      getFromActiveStage: getFromActiveStage,
      getConifgWithoutStage: getConifgWithoutStage,
      requestType: contarctName
    }

    return this.http.post<any>(this.baseUrl + `/Documents/GetDocumentsConfigurations`, model);
  }

  GetDocumentsConfigurationsForServiceEntity(requestModel: any, contarctName: string, getConifgWithoutStage: boolean = false, getFromActiveStage: boolean = false, ): Observable<IDocumentConfiguration[]> {
    const model = {
      Request: requestModel,
      origin: [DocumentOrigin.Portal, DocumentOrigin.Both],
      getFromActiveStage: getFromActiveStage,
      getConifgWithoutStage: getConifgWithoutStage,
      requestType: contarctName
    }

    return this.http.post<any>(this.baseUrl + `/Documents/GetDocumentsConfigurationsForServiceEntity`, model);
  }
  
  IsProduction(keys: any, url:string): Observable<object> {

    return this.http.post<any>(url + `GetListConfigurationKeys`, keys);
  }
  //------------------------- share session storage between tabs --------------------
  sessionStorage_transfer(event): Promise<any> {

    return new Promise((resolve, reject) => {
      if (!event) { event = window.event; } // ie suq
      if (!event.newValue) return;          // do nothing if no value to work with
      if (event.key == 'getSessionStorage') {
        // another tab asked for the sessionStorage -> send it
        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        // the other tab should now have it, so we're done with it.
        localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
      } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
        // another tab sent data <- get it
        var data = JSON.parse(event.newValue);
        for (var key in data) {
          sessionStorage.setItem(key, data[key]);
        }
      }
      // @ts-ignore
      resolve();
    });
  }

  localStorageEvent(): Promise<any> {
    this.isNewTab = false;
    return new Promise((resolve, reject) => {
      if (window.addEventListener) {
        window.addEventListener("storage", this.sessionStorage_transfer, false);
        this.isNewTab = true;
      } else {
        // for IE
        (<any>window).attachEvent("onstorage", this.sessionStorage_transfer);
        this.isNewTab = true;
      }

      // Ask other tabs for session storage (this is ONLY to trigger event)
      if (!sessionStorage.length) {
        localStorage.setItem('getSessionStorage', 'foobar');
        localStorage.removeItem('getSessionStorage');
      }
      console.log("session has been trasfered");
      // @ts-ignore
      resolve();
    });
  }
  
  catchError(error) {
    if (error && error.error) {
      let backLableText = '';  
      let alertHeader = '';
      let initialState={};
      this.translate.get("OperatingCardIssuanceRequest-container.buttons.backLableText")
      .subscribe(value => backLableText = value);
      this.translate.get("OperatingCardIssuanceRequest-container.Messages.Alert.IdevedualHeader")
      .subscribe(value => alertHeader = value);

      if (error.error.Status == ErrorStatus.ValidationException) {
        if(error.error.RedirectionCode==RedirectionCode.NoRedirection){
          initialState=this.setPopupValues(alertHeader,error.error.Message,false,'',false,'');
        }else if(error.error.RedirectionCode==RedirectionCode.RedirectWithURL){
          initialState=this.setPopupValues(alertHeader,error.error.Message,true,error.error.RedirectionUrl,true,error.error.RedirectionUrl);
        }else {
          initialState=this.setPopupValues(alertHeader,error.error.Message,true,'home',true,'home');
        }


        // const initialState = {
        //       alertMode: Mode.Error,
        //       alertHeader: alertHeader,
        //       alertMassage: error.error.Message,
        //       navigateOnExit: true,
        //       exitNavigationURL: 'home',
        //       enableNavigation: true,
        //       enableRichText: true,
        //       navigationURL: 'workspace'
        //     };
            this.alertModalRef = this.modalService.show(
              PopupNotificationComponent,
               {initialState,
                backdrop: true,
                ignoreBackdropClick: true,
                keyboard: false});
      }
      else if(error.error.Status == ErrorStatus.Unauthorized){
        this.router.navigateByUrl('/unauthorized');
      }
      else if (error.error.Status == ErrorStatus.GlobalExeption) {
        initialState=this.setPopupValues(alertHeader,error.error.Message,true,'error',true,'error');
        this.alertModalRef = this.modalService.show(
          PopupNotificationComponent,
          {initialState,
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false});
        //this.router.navigateByUrl('/error');
      }
    } else {
      this.router.navigateByUrl('error');
    }
  }
   setPopupValues(alertHeader,errorMessage,NavigationOnExit,exitNavigationUrl,enableNavigation,navigationURL):any{
     const initialState={
      alertMode: Mode.Error,
      alertHeader: alertHeader,
      alertMassage: errorMessage,
      navigateOnExit: NavigationOnExit,
      exitNavigationURL: exitNavigationUrl,
      enableNavigation: enableNavigation,
      enableRichText: true,
      navigationURL: navigationURL
    };
    return initialState;
  }

//#region [angular State]
    //------------------------- handel angular State on refreshing --------------------
    storeAngularState(angularState: any){
      this.dbService.getAll('angularState').then(
        states => {
            console.log(states);
            if (states && states.length > 0) {
              this.dbService.clear('angularState').then( () => {}, error => { console.log(error);});
            }
            this.dbService.add('angularState', {state: angularState}).then(
              () => {},
              error => {
                console.log(error);
              }
            );
        },
        error => {
            console.log(error);
        }
    );
    }
    retrieveAngularState() {
      this.dbService.getAll('angularState').then(
        states => {
          if (states && states.length > 0) {
            history.pushState(states[0],'',null);
            if (history.state) {
              console.log(history.state);
            }
          }
        },
        error => {
          console.error(error);
        }
      );
    }
    //#endregion

}
